import React from 'react';
import { SelectReseller } from '../components/constructed';

const SelectResellerPage = () => {
    return <SelectReseller />;
};

export { SelectResellerPage };
